import store from '@/store';
import Http from '@/utils/http/index';
export default {
  /**
   * 交易查询列表
   */
  getTransactionList(params = {}) {
    const obj = {};
    const keys = Object.keys(params);
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      if (!params.keywords) {
        obj[k] = params[k];
      } else if (k !== 'startTime' && k !== 'endTime') {
        // 当存在 keywords(流水号) 时，忽略时间限制
        obj[k] = params[k];
      }
    }
    if (obj.txnStatus && (typeof obj.txnStatus === 'object') && obj.txnStatus.length) {
      obj.txnStatus = obj.txnStatus.join(',');
    }
    return Http.get('/trade/list', { params: obj });
  },

  /**
   * 交易时间线列表
   */
  queryTransactionTimelineList(id) {
    return Http.get(`/trade/txnTimeline/${id}`);
  },

  /**
   * 下载交易列表
   */
  downloadTransaction(params) {
    const obj = {};
    const keys = Object.keys(params);
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      if (!params.keywords) {
        obj[k] = params[k];
      } else if (k !== 'startTime' && k !== 'endTime') {
        // 当存在 keywords(流水号) 时，忽略时间限制
        obj[k] = params[k];
      }
    }
    return Http.get('/trade/downloadTxn', { params: obj });
  },

  /**
   * 交易详情查询
   */
  getTransactionDetails(id, params = {}) {
    let prefix = '';
    const merchantType = store.getters.app.userLogin && store.getters.app.userLogin.merchantType ? store.getters.app.userLogin.merchantType : '';
    try {
      if (`${merchantType}` === '3') { // 集团商户时，需要判断是否更换接口
        prefix = '/blocMer';
      }
    } catch (err) {
      //
    }
    return Http.get(`${prefix}/trade/detail/${id}`, { params });
  },
  /**
   * 交易退款
   */
  postRefundAmount(params) {
    return Http.post('/rf/refundApply', params);
  },
  /**
   * 上传物流单号
   */
  uploadTrackingNumber(file) {
    const param = new FormData(); // 创建form对象
    param.append('file', file);
    return Http.post('/trade/uploadTrackingNumber', param, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  /**
   * 批量退款
   */
  batchRefund(file) {
    const param = new FormData(); // 创建form对象
    param.append('file', file);
    return Http.post('/trade/batchRefund', param, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  /**
   * 批量查询
   */
  batchQuery(file) {
    const param = new FormData(); // 创建form对象
    param.append('file', file);
    return Http.post('/trade/batchQuery', param, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
